/* global  */ // tUrl等のグローバル変数を宣言する

import './_smoothScroll.js' // スムーズスクロール
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  // body...
  //menuBar
  $('.menuBar').on('click', function() {
    $(this).toggleClass('on')
    $('.nav-wrap').toggleClass('on')
    $('body').toggleClass('noScroll')
  })

  if ($(window).width() < 921) {
    $('.hasChild > a').click(function(e) {
      e.preventDefault()
      $(this).toggleClass('on')
      $(this)
        .next('.subMenu')
        .slideToggle()
      // $(".nav-wrap").toggleClass("active")
    })

    $('.nav-wrap ').css('height', $(window).outerHeight())
  } else {
    $('.nav-item').hover(
      function() {
        $(this)
          .find('.subMenu')
          .fadeIn(300)
      },
      function() {
        $('.subMenu').fadeOut(300)
      }
    )
  }

  //slick slider
  $('.listSlider').slick({
    autoplay: true,
    autoplaySpeed: 7000,
    fade: true,
    cssEase: 'linear'
  })

  $('.listBlog, .listStrength').slick({
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  })

  var windowType
  var $window = $(window)
  if ($window.width() <= 768) {
    windowType = 'sp'
  } else {
    windowType = 'pc'
  }
  $(window).resize(function() {
    if ($window.width() <= 768) {
      if (windowType !== 'sp') {
        location.reload()
      }
    } else {
      if (windowType !== 'pc') {
        location.reload()
      }
    }
  })

  //matched
  $(window).on('load resize', function() {
    $('.logoGroup .listLogo .item').matchHeight()
    $(
      '.adv-strengths .adv-strengths-inner .listStrength .item .item-content .item-content-head'
    ).matchHeight()
  })

  //scroll to id
  $('a[href^="#"]').click(function(e) {
    e.preventDefault()
    var headerHeight = $('#main-header').outerHeight()
    var speed = 400
    var href = jQuery(this).attr('href')
    var target = jQuery(href === '#' || href === '' ? 'html' : href)
    var position = target.offset().top - headerHeight
    $('body,html').animate({ scrollTop: position }, speed, 'swing')
    return false
  })

  //HIDE MENU
  $('.subMenu-inner .sub-item a ').click(function() {
    $('.menuBar').removeClass('on')
    $('.nav-wrap').removeClass('on')
    $('body').removeClass('noScroll')
  })
  //your current click function

  var headerHeight = $('#main-header').outerHeight()
  // if we have anchor on the url (calling from other page)
  if (window.location.hash) {
    // smooth scroll to the anchor id
    $('html,body').animate(
      {
        scrollTop: $(window.location.hash).offset().top - headerHeight
      },
      500
    )
  }

  /*
       ######## ########  ##     ## ##    ## ##    ##  #######
          ##    ##     ## ##     ## ###   ## ##   ##  ##     ##
          ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
          ##    ########  ##     ## ## ## ## #####     #######
          ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
          ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
          ##    ##     ##  #######  ##    ## ##    ##  #######
*/
  function trunk8() {
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }
  if ($('.js-t8')[0]) {
    // 要素を検出したら実行
    trunk8()
    $(window).on('load resize ', function() {
      trunk8()
    })
  }

  /*
       ##     ##    ###     ######           ########   #######  ########  ##     ## ########
       ###   ###   ## ##   ##    ##          ##     ## ##     ## ##     ## ##     ## ##     ##
       #### ####  ##   ##  ##                ##     ## ##     ## ##     ## ##     ## ##     ##
       ## ### ## ##     ## ##   #### ####### ########  ##     ## ########  ##     ## ########
       ##     ## ######### ##    ##          ##        ##     ## ##        ##     ## ##
       ##     ## ##     ## ##    ##          ##        ##     ## ##        ##     ## ##
       ##     ## ##     ##  ######           ##         #######  ##         #######  ##
*/
  // Safariで画面を固定する処理
  const displayHold = function(event) {
    event.preventDefault()
  }
  $('.mag-popup').magnificPopup({
    //  delegate:'',    //子要素を開く場合のセレクタ
    closeMarkup: '', //閉じるボタンのマークアップ（空にして自作推奨）
    type: 'image', //iframe/image/inline/ajax
    callbacks: {
      beforeOpen: function() {
        window.addEventListener('touchmove', displayHold, { passive: false })
      },
      resize: function() {},
      open: function() {
        // スクロール停止
        $('body').addClass('lock')
        window.addEventListener('touchmove', displayHold, { passive: false })
      },
      beforeClose: function() {},
      afterClose: function() {
        // スクロール停止解除
        $('body').removeClass('lock')
        window.removeEventListener('touchmove', displayHold, { passive: false })
      }
    }
  })
})
